import { convertReserveToCommand_service } from "@Services/reserve/convertReserveToCommand.service";

export const putConvertReserveToCommand_adapter = async (reserveId: number) => {
  const response = await convertReserveToCommand_service(reserveId);
  return response;
};
